import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { Injectable } from '@angular/core';
import { Inspection } from '../shared/models';
import { InspectionService } from '../shared/services/inspection.service';

@Injectable({
  providedIn: 'root'
})
export class InspectionResolver {
  constructor(private inspectionService: InspectionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Inspection> {
    const inspectionId = this.findParam(route, 'inspectionId');
    if (!inspectionId) {
      return of(null);
    }
    return this.inspectionService.getInspection(inspectionId);
  }

  private findParam(route: ActivatedRouteSnapshot, param: string): string | null {
    if (route.paramMap.has(param)) {
      return route.paramMap.get(param);
    }
    for (const child of route.children) {
      const result = this.findParam(child, param);
      if (result) return result;
    }
    return null;
  }
}
